<template>
  <div class="bc-ticketing">
    <div class="bc-ticketing__inner">
      <h1 class="bc-ticketing__title">{{ $T('官网票务页标题') }}</h1>
      <p class="bc-ticketing__desc">{{ $T('官网票务页说明') }}</p>
      <div class="bc-ticketing__qr-wrap">
        <img
          class="bc-ticketing__qr"
          :src="qrSrc"
          :alt="$T('官网票务扫码购票')"
        />
      </div>
      <p class="bc-ticketing__hint">{{ $T('官网票务扫码购票') }}</p>
      <a
        class="bc-ticketing__btn"
        :href="damaiUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $T('官网票务前往大麦') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ticketing',
  data() {
    return {
      damaiUrl: 'https://detail.damai.cn/item.htm?id=1090430646662',
      qrSrc: require('@/assets/images/mainindex/damai-ticketing-qr.png'),
    };
  },
};
</script>

<style lang="scss" scoped>
.bc-ticketing {
  background: #f3f4f6;
  min-height: 50vh;
  padding: 48px 24px 80px;
}
.bc-ticketing__inner {
  max-width: 560px;
  margin: 0 auto;
  text-align: center;
}
.bc-ticketing__title {
  margin: 0 0 12px;
  font-size: 28px;
  font-weight: 700;
  color: #1e2842;
  letter-spacing: 0.02em;
}
.bc-ticketing__desc {
  margin: 0 0 32px;
  font-size: 15px;
  line-height: 1.6;
  color: #5b6478;
}
.bc-ticketing__qr-wrap {
  display: inline-block;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 28px rgba(30, 40, 66, 0.08);
}
.bc-ticketing__qr {
  display: block;
  width: 240px;
  height: 240px;
  object-fit: contain;
}
.bc-ticketing__hint {
  margin: 20px 0 28px;
  font-size: 14px;
  color: #6b7280;
}
.bc-ticketing__btn {
  display: inline-block;
  padding: 12px 28px;
  border-radius: 8px;
  background: #6b21a8;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s;
}
.bc-ticketing__btn:hover {
  background: #581c87;
  color: #fff;
}

@media (max-width: 640px) {
  .bc-ticketing {
    padding: 32px 16px 64px;
  }
  .bc-ticketing__title {
    font-size: 22px;
  }
  .bc-ticketing__qr {
    width: 200px;
    height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// Ticketing.vue?4f859b43